import { useMutation } from '@tanstack/react-query';
import axiosInstance from 'ns_libs/nsAxios';
import API_ENDPOINTS from 'services/urls';

interface RemoveTimelineDocumentParams {
    orgId: string;
    dealId: number;
    timelineId: number;
    documentId: number;
}

const removeTimelineDocument = async ({ orgId, dealId, timelineId, documentId }: RemoveTimelineDocumentParams): Promise<void> => {
    await axiosInstance.delete(API_ENDPOINTS.TIMELINE_DOCUMENT_BY_ID(orgId, dealId, timelineId, documentId));
};

export const useRemoveTimelineDocument = () => useMutation({
    mutationFn: removeTimelineDocument,
});

export default useRemoveTimelineDocument;
